import React from "react";
import seller from "./seller";

const wrap = { maxWidth: 760, margin: "0 auto", padding: "24px 16px 64px", lineHeight: 1.6, fontSize: 16 };

const Terms = () => (
  <div style={wrap}>
    <h1>Условия использования приложения «Спроси»</h1>
    <p>Редакция от {seller.updated}</p>

    <h2>1. Общие положения</h2>
    <p>
      1.1. Настоящие Условия регулируют использование мобильного приложения «Спроси» и сайта https://sprosi.link
      (далее вместе — «Сервис»), правообладателем которых является {seller.name} (далее — «Администрация»).
    </p>
    <p>
      1.2. Начиная использовать Сервис, вы подтверждаете, что полностью прочитали и принимаете настоящие Условия, а
      также Политику конфиденциальности (https://sprosi.link/policy). Если вы не согласны с ними, использование Сервиса
      необходимо прекратить.
    </p>
    <p>
      1.3. Администрация вправе изменять Условия. Актуальная редакция всегда доступна по адресу
      https://sprosi.link/terms. Продолжая пользоваться Сервисом после публикации изменений, вы принимаете новую
      редакцию.
    </p>

    <h2>2. Описание Сервиса</h2>
    <p>
      2.1. Сервис позволяет пользователю получить персональную ссылку, поделиться ею (например, в социальных сетях) и
      получать по ней анонимные вопросы и сообщения от других лиц, а также отвечать на них и публиковать ответы.
    </p>
    <p>
      2.2. Базовые функции Сервиса предоставляются бесплатно. Отдельные дополнительные функции предоставляются на
      платной основе (раздел 8).
    </p>
    <p>
      2.3. Сервис предоставляется «как есть». Администрация вправе изменять, добавлять и прекращать отдельные функции.
    </p>

    <h2>3. Учётная запись</h2>
    <p>
      3.1. Учётная запись создаётся автоматически при первом запуске Приложения; имя пользователя выбирается вами
      самостоятельно. Регистрация по паролю не требуется.
    </p>
    <p>
      3.2. Доступ к учётной записи привязан к вашему устройству. Вы отвечаете за сохранность устройства и за все
      действия, совершённые в Сервисе с его помощью.
    </p>
    <p>
      3.3. Запрещается выбирать имя пользователя, которое вводит в заблуждение, нарушает права третьих лиц (в том числе
      на товарные знаки) либо является оскорбительным.
    </p>

    <h2>4. Возрастные ограничения</h2>
    <p>
      4.1. Сервис предназначен для лиц, достигших 18 лет. Используя Сервис, вы подтверждаете, что достигли этого
      возраста и обладаете дееспособностью, необходимой для заключения договора.
    </p>

    <h2>5. Правила использования</h2>
    <p>5.1. Запрещается отправлять, публиковать и распространять через Сервис материалы, которые:</p>
    <ul>
      <li>нарушают законодательство Российской Федерации или призывают к его нарушению;</li>
      <li>содержат оскорбления, угрозы, травлю, шантаж или разжигание вражды;</li>
      <li>содержат порнографию, сцены насилия или материалы, вредные для несовершеннолетних;</li>
      <li>раскрывают персональные данные третьих лиц без их согласия;</li>
      <li>нарушают авторские, смежные или иные права третьих лиц;</li>
      <li>содержат спам, рекламу, мошеннические схемы, вредоносный код или ссылки на него;</li>
      <li>выдают вас за другое лицо, в том числе за представителя Администрации.</li>
    </ul>
    <p>
      5.2. Запрещается вмешиваться в работу Сервиса: получать доступ к чужим учётным записям, создавать
      автоматизированную нагрузку, использовать ботов и парсеры, декомпилировать и модифицировать Приложение, обходить
      технические ограничения, включая ограничения платных функций.
    </p>
    <p>
      5.3. Вы несёте самостоятельную ответственность за содержание отправляемых и публикуемых вами материалов и за
      последствия их распространения.
    </p>

    <h2>6. Модерация</h2>
    <p>
      6.1. Администрация вправе, но не обязана проверять материалы пользователей, применять автоматические фильтры
      спама и нежелательного содержания, удалять материалы и ограничивать или прекращать доступ к Сервису при нарушении
      настоящих Условий — без предварительного уведомления.
    </p>
    <p>
      6.2. Сообщить о нарушении или пожаловаться на сообщение можно средствами Приложения либо письмом на {seller.email}.
      Обращения рассматриваются в разумный срок, как правило в течение 10 календарных дней.
    </p>

    <h2>7. Анонимность и её пределы</h2>
    <p>
      7.1. Сервис не раскрывает получателю имя, контакты или учётную запись отправителя анонимного вопроса.
    </p>
    <p>
      7.2. Платные функции «СпросиPRO» показывают только технические сведения, определяемые автоматически по данным
      соединения: предполагаемый город, тип устройства и браузер. Эти сведения носят вероятностный характер, могут быть
      неточными и не позволяют установить личность отправителя.
    </p>
    <p>
      7.3. Анонимность не является абсолютной: в предусмотренных законом случаях сведения могут быть предоставлены
      уполномоченным государственным органам по надлежащим образом оформленному запросу.
    </p>

    <h2>8. Платные функции</h2>
    <p>
      8.1. Платная подписка «СпросиPRO» предоставляет доступ к функциям, указанным в п. 7.2, стоит 999 ₽ за 7 дней и
      продлевается автоматически каждые 7 дней до отмены.
    </p>
    <p>
      8.2. Если оплата производится напрямую в Приложении или на Сайте (через платёжный сервис ЮKassa), к ней
      применяется Публичная оферта: https://sprosi.link/offer. В ней же описаны порядок автопродления, отмены подписки и
      возврата денежных средств.
    </p>
    <p>
      8.3. Если подписка оформлена через App Store или Google Play, оплата, продление, отмена и возврат регулируются
      правилами соответствующего магазина, а управление подпиской производится в настройках вашей учётной записи в
      магазине.
    </p>
    <p>8.4. Отменить подписку можно в любой момент: «Настройки» → «Управление подпиской» в Приложении.</p>

    <h2>9. Интеллектуальная собственность</h2>
    <p>
      9.1. Приложение, Сайт, их оформление, логотипы и программный код принадлежат Администрации и защищены
      законодательством об интеллектуальной собственности. Использование возможно только в рамках функциональности
      Сервиса.
    </p>
    <p>
      9.2. Права на материалы, создаваемые пользователями, сохраняются за ними. Публикуя материалы в Сервисе, вы
      предоставляете Администрации безвозмездное право хранить, воспроизводить и показывать их другим пользователям в
      объёме, необходимом для работы Сервиса.
    </p>

    <h2>10. Ограничение ответственности</h2>
    <p>
      10.1. Сервис предоставляется «как есть». Администрация не гарантирует бесперебойную и безошибочную работу,
      сохранность пользовательских материалов и соответствие Сервиса вашим ожиданиям.
    </p>
    <p>
      10.2. Администрация не несёт ответственности за содержание сообщений, отправленных другими пользователями, и за
      последствия их получения.
    </p>
    <p>
      10.3. Ответственность Администрации в любом случае ограничена суммой, фактически уплаченной вами за платные
      функции за период, в котором возникли основания для ответственности. Настоящий пункт не ограничивает права
      потребителя, предусмотренные законодательством Российской Федерации.
    </p>

    <h2>11. Прекращение использования</h2>
    <p>
      11.1. Вы можете прекратить использование Сервиса в любой момент, удалив Приложение. Если у вас оформлена платная
      подписка, её необходимо отдельно отменить способом, описанным в п. 8.4 — удаление Приложения автопродление не
      отключает.
    </p>
    <p>
      11.2. Удалить учётную запись и связанные с ней данные можно по запросу на {seller.email} либо средствами
      Приложения, если такая функция доступна.
    </p>

    <h2>12. Персональные данные</h2>
    <p>
      12.1. Состав обрабатываемых данных, цели и сроки обработки описаны в Политике конфиденциальности:
      https://sprosi.link/policy. Обработка осуществляется в соответствии с Федеральным законом № 152-ФЗ.
    </p>

    <h2>13. Применимое право и споры</h2>
    <p>
      13.1. К настоящим Условиям применяется право Российской Федерации. Споры решаются путём переговоров с обязательным
      претензионным порядком (срок ответа — 10 календарных дней), а при недостижении согласия — в суде в соответствии с
      законодательством Российской Федерации.
    </p>

    <h2>14. Контакты</h2>
    <p>
      {seller.name}<br />
      ИНН: {seller.inn}<br />
      ОГРНИП: {seller.ogrnip}<br />
      Адрес: {seller.address}<br />
      Электронная почта: {seller.email}<br />
      Служба поддержки: {seller.telegram}
    </p>
  </div>
);

export default Terms;
